import Types from '../types'

const initialState = {
    allCredentials: []
};
export default function credentialReducer(state = initialState, action) {
    switch (action.type) {
        case Types.ALL_CREDENTIALS:
            return {
                ...state,
                allCredentials: action.payload
            };
        default:
            return state;
    }
}
